import {request} from '@/network/request'
import qs from "qs";
export function fetchList(obj) {
  // let dataArr = qs.stringify({query})
  return request({
    url: '/gaoligong/seednew/getSeedNew',
    method: 'post',
    data:  obj
  })
}


export function addObj(obj) {
  return request({
    url: '/gaoligong/seeds',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/seednew/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/seeds/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/seeds',
    method: 'put',
    data: obj
  })
}
export function getSeedNewResourceType() {
  return request({
    url: '/gaoligong/seednew/getSeedNewResourceType',
    method: 'get',
  })
}
export function getAnimalGermplasmNewResourceType() {
  return request({
    url: '/gaoligong/animalgermplasmnew/getAnimalGermplasmNewResourceType',
    method: 'get'
  })
}
